export const replaceLocation = url => window.location.replace(url);
